// extracted by mini-css-extract-plugin
export default {"container":"WhyUs_container__qR-DD","content":"WhyUs_content__QkvqE","cardsLists":"WhyUs_cardsLists__f0zxr","card":"WhyUs_card__UxR19","imgContainer":"WhyUs_imgContainer__+bzm6"};